import { AbilityBuilder } from '@casl/ability';
import { ROLES } from 'models/User';
import { ACTION_TYPES, ABILITY_TYPES } from './types';

const abilitiesMap = {
  [ROLES.ADMIN]: () => {
    const ability = AbilityBuilder.define((can) => {
      can(
        [ACTION_TYPES.READ, ACTION_TYPES.CREATE, ACTION_TYPES.UPDATE],
        ABILITY_TYPES.ATHLETE,
      );
    });
    return ability;
  },
  [ROLES.SECRETARY]: () => {
    const ability = AbilityBuilder.define((can) => {
      can([], ABILITY_TYPES.ATHLETE);
    });
    return ability;
  },
  [ROLES.ATHLETE_SUPPORT]: () => {
    const ability = AbilityBuilder.define((can) => {
      can(
        [ACTION_TYPES.READ, ACTION_TYPES.CREATE, ACTION_TYPES.UPDATE],
        ABILITY_TYPES.ATHLETE,
      );
    });
    return ability;
  },
  [ROLES.ADMIN_VIEW_ONLY]: () => {
    const ability = AbilityBuilder.define((can) => {
      can([ACTION_TYPES.READ], ABILITY_TYPES.ATHLETE);
    });
    return ability;
  },
  [ROLES.MEMBERSHIP_ADMIN]: () => {
    const ability = AbilityBuilder.define((can) => {
      can(
        [ACTION_TYPES.READ, ACTION_TYPES.CREATE, ACTION_TYPES.UPDATE],
        ABILITY_TYPES.ATHLETE,
      );
    });
    return ability;
  },
  [ROLES.SALES_REP]: () => {
    const ability = AbilityBuilder.define((can) => {
      can(
        [ACTION_TYPES.READ, ACTION_TYPES.CREATE, ACTION_TYPES.UPDATE],
        ABILITY_TYPES.ATHLETE,
      );
    });
    return ability;
  },
};

export default function athlete(role = ROLES.USER) {
  const fn = abilitiesMap[role];
  return fn();
}
